<template>
    <div
        class="da-ui--button"
        :class="['da-ui--button_' + type]"
        @click="click"
    >
        <slot />
    </div>
</template>


<script>
export default {
    name: 'Button',

    props: {
        type: {
            type: String,
            default: 'default'
        },
        click: {
            type: Function,
            default: () => null,
        },
    }
}
</script>

<style lang='scss' scoped>
.da-ui--button {
    display: inline-block;
    font-size: 14px;
    line-height: 15px;
    text-transform: uppercase;
    text-align: center;
    padding: 14px 20px;
    border-radius: 8px;
    user-select: none;
    cursor: pointer;
    font-weight: bold;
    transition: all .2s;
    word-wrap: normal;
    white-space: nowrap;
    border: 1px solid transparent;

    svg {
        display: inline-block;
        vertical-align: middle;
        line-height: inherit;
        margin-right: 10px;
        transition: all .2s;
    }

    span {
        vertical-align: middle;
    }

    &_default {
        background: #fff;
        border: 1px solid #e8e8e8;
        color: rgba(31, 31, 31, 1);

        // &:hover {
        //     border-color: #999;
        // }
    }

    &_primary {
        background: #f58705 linear-gradient(257deg, #f59c07, #f57507);
        color: #fff;

        // &:hover {
        //     opacity: .8;
        // }

        &:hover {
            background: #fff;
            color: #f57507;
        }
    }

    &_dark {
        background: #303030;
        color: #f1f1f1;

        &:hover {
            background: #464646;
        }
    }
}
</style>